import {createContext, useEffect, useState} from 'react'
import { makeRequest } from '../axios'
 
 
export const AuthContext = createContext()



export const AuthContextProvider = ({children}) => {

    const isValidJSON = (str) => {
        
        try {
            
            JSON.parse(str)
            
            return true;
          } catch (e) {
          
            makeRequest.get('/login/logout')
            localStorage.removeItem('expiration')
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            return false;
        }        
    }

    isValidJSON(localStorage.getItem("user"))
    

    const [currentUser, setCurrentUser] = useState(
        JSON.parse(localStorage.getItem("user")) || null
    ) 

    const [loading, setLoading] = useState(false)
    
    const login = async (inputs) => {

            setLoading(true)
            const res = await makeRequest.post('/login', inputs).finally(() => {
                setLoading(false)
            })

            setTimeout(() => {
                logout() 
            }, 2 * 60 * 60 * 1000)

            setCurrentUser(res.data.userData)
            const expiration = new Date()
            expiration.setHours(expiration.getHours() + 2)
            localStorage.setItem('expiration', expiration.toISOString())
            localStorage.setItem('token', res.data.token)
                   
    }


    const getTokenDuration = () => {
        const storedExpirationDate = localStorage.getItem('expiration')
        const expirationDate = new Date(storedExpirationDate)
        const now = new Date();
        const duration = expirationDate.getTime() - now.getTime()
        return duration
    }

    const getAuthToken = () => {
        const token = localStorage.getItem('token')

        if(!token) {
            return null
        }
        const tokenDuration = getTokenDuration();

        if(tokenDuration < 0){
            return 'EXPIRED'
        }

        return token
    }
 

 
    const regGet = async () => {

        setLoading(true)
        const res = await makeRequest.get('/reg').finally(() => {
            setLoading(false)
        }) 
        return res;     
    } 

    const reg = async(inputs) => {
        setLoading(true)
        const res = await makeRequest.post('/reg', inputs).finally(() => {
            setLoading(false)
        })
        return res;
    }

    const logout = async () => {
        const res = await makeRequest.get('/login/logout')
        localStorage.removeItem('expiration')
        localStorage.removeItem('token')
        setCurrentUser(null)
        return res
    }


    const checkLocalUser = () => {
        const localUser = {
            id: 1,
            iin: "",
            name: "",
            surname: "",
            num_ap: "",
            admin: "",
            active: ""
        }

        
        try {
            
            for(let key in localUser) {
                if(!currentUser.hasOwnProperty(key) || !JSON.parse(localStorage.getItem("user")).hasOwnProperty(key) ) {
                    logout();
                } 
                // if(!currentUser.hasOwnProperty(key) ) {
                //     logout();
                // } 
              
            }
        } catch(err) {
            // console.log(err);
            logout();
        }
        
        
    }



    useEffect(() => {

        localStorage.setItem("user", JSON.stringify(currentUser));

    }, [currentUser]);

   


    

    return (
        <AuthContext.Provider value={{ currentUser, login, loading, logout, regGet, reg, getAuthToken, getTokenDuration, checkLocalUser }}>
          {children}
        </AuthContext.Provider>
    );
}